module.exports = __webpack_public_path__ + "static/media/07_insideyourblood.12feaf20.jpg";